import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ComponentDisableState {
    navMenuDisabled: boolean;
    headerMenuDisabled: boolean;
};

const initialState: ComponentDisableState = {
    navMenuDisabled: false,
    headerMenuDisabled: false,
};

export const componentDisableSlice = createSlice({
    name: 'componentDisable',
    initialState,
    reducers: {
        setNavMenuDisabled: (state, action: PayloadAction<boolean>) => {
            state.navMenuDisabled = action.payload;
        },
        setHeaderMenuDisabled: (state, action: PayloadAction<boolean>) => {
            state.headerMenuDisabled = action.payload;
        },
    }
});

export const { setNavMenuDisabled, setHeaderMenuDisabled } = componentDisableSlice.actions;

export default componentDisableSlice.reducer;